// MAIN SCRIPTS

// $('.product .image').zoom();

$('.thumbnail img').click(function(event) {
	galleryIndex = parseFloat($(this).attr('index'));
	console.log(galleryIndex, 'index');
	$('.product .image img').attr('src', $(this).attr('full'));
	changeSelected();
})

$('.thumbnail img').mouseenter(function(event) {
	galleryIndex = parseFloat($(this).attr('index'));
	console.log(galleryIndex, 'index');
	$('.product .image img').attr('src', $(this).attr('full'));
	changeSelected();
})

$('.product .image img').click(function(event) {
	$('.popImage').show();
	$('.popImage img').attr('src', $('.product .image img').attr('src'));	

	if(galleryIndex <= 1) {
		galleryIndex = 1;
		$('.leftArrow').addClass('disabled');
	}

	if(galleryIndex >= parseFloat($('.lastGallery').attr('index'))) {
		galleryIndex = parseFloat($('.lastGallery').attr('index'));
		$('.rightArrow').addClass('disabled');
	}
})

$('.thumbnail img').dblclick(function(event) {
	$('.popImage').show();
	$('.popImage img').attr('src', $(this).attr('full'));

	galleryIndex = parseFloat($(this).attr('index'));

	console.log(galleryIndex, 'index')

	if(galleryIndex <= 1) {
		galleryIndex = 1;
		$('.leftArrow').addClass('disabled');
	}

	if(galleryIndex >= parseFloat($('.lastGallery').attr('index'))) {
		galleryIndex = parseFloat($('.lastGallery').attr('index'));
		$('.rightArrow').addClass('disabled');
	}
})

$('.explainerPopup').click(function(event) {
	$('.popExplainer').show();
	$('.popExplainerIMG').attr('src', $('.explainerPopup').attr('image'));
})

$('.modalWrapper .underlay').click(function(event) {
	$(this).parents('.modalWrapper').hide();
})

$('.modal-closer a').click(function(event) {
	$(this).parents('.modalWrapper').hide();
})

function changeSelected() {
	$('.thumbnail img').removeClass('selected');
	$('.thumbnail img').each(function() {
		if($('.product .image img').attr('src') == $(this).attr('full')) {
			$(this).addClass('selected');
		}
	})
}
changeSelected();

$('.mobileMenuToggle').on('click', function(event) {
	$('.mobileMenu').toggle();
})

var galleryIndex = 1;
$('.popImageWrapper .leftArrow').on('click', function(event) {
	decrementGallery();
});
function decrementGallery() {
	$('.rightArrow').removeClass('disabled');
	$('.leftArrow').removeClass('disabled');

	galleryIndex = parseFloat(galleryIndex) - 1;
	if(galleryIndex <= 1) {
		galleryIndex = 1;
		$('.leftArrow').addClass('disabled');
	}

	if($(`.thumbnail${galleryIndex}`).is(':visible')) {
		$('.popImage img').attr('src', $(`.thumbnail${galleryIndex}`).attr('full'));
	} else {
		decrementGallery();
	}
}

$('.popImageWrapper .rightArrow').on('click', function(event) {
	incrementGallery();
});
function incrementGallery() {

	$('.rightArrow').removeClass('disabled');
	$('.leftArrow').removeClass('disabled');

	galleryIndex = parseFloat(galleryIndex) + 1;
	console.log(galleryIndex, parseFloat($('.lastGallery').attr('index')), 'comparison');
	if(galleryIndex >= parseFloat($('.lastGallery').attr('index'))) {
		galleryIndex = parseFloat($('.lastGallery').attr('index'));
		$('.rightArrow').addClass('disabled');
	}

	if($(`.thumbnail${galleryIndex}`).is(':visible')) {
		$('.popImage img').attr('src', $(`.thumbnail${galleryIndex}`).attr('full'));
	} else {
		incrementGallery();
	}
}

window.addEventListener("keydown", function (event) {
  if (event.defaultPrevented) {
    return; // Do nothing if the event was already processed
  }

  switch (event.key) {
    case "Down": // IE/Edge specific value
    case "ArrowDown":
      // Do something for "down arrow" key press.
      break;
    case "Up": // IE/Edge specific value
    case "ArrowUp":
      // Do something for "up arrow" key press.
      break;
    case "Left": // IE/Edge specific value
    case "ArrowLeft":
      // Do something for "left arrow" key press.
      decrementGallery();
      break;
    case "Right": // IE/Edge specific value
    case "ArrowRight":
      // Do something for "right arrow" key press.
      incrementGallery();
      break;
    case "Enter":
      // Do something for "enter" or "return" key press.
      break;
    case "Esc": // IE/Edge specific value
    case "Escape":
      // Do something for "esc" key press.
      break;
    default:
      return; // Quit when this doesn't handle the key event.
  }

  // Cancel the default action to avoid it being handled twice
  event.preventDefault();
}, true);